import { Domicilio } from "./Domicilio";

interface _FileDocument {
    id: number,
    tipo_archivo: string,
    filename: string,
    fullpath: string,
    mime_type: string,
    url: string
}

class FileDocument implements _FileDocument {
    id: number = 0;
    tipo_archivo: string = '';
    filename: string = '';
    fullpath: string = '';
    mime_type: string = '';
    url: string = '';

    constructor() {
        this.id = 0;
        this.tipo_archivo = '';
        this.filename = '';
        this.fullpath = '';
        this.mime_type = '';
        this.url = '';
    }
}

interface _SolicitudTorres {
    id: number,
    folio: string,
    contribuyente_id: number,
    clave_catastral: string,
    no_folio: boolean,
    domicilio_id: number,
    domicilio: Domicilio | null,
    altura_mts: string,
    referencias: string | null,
    luz: boolean,
    bardeado: boolean,
    colindansia_norte: string | null,
    colindansia_sur: string | null,
    colindansia_este: string | null,
    colindansia_oeste: string | null,
    fachada: string | null,
    torre_perspectiva: string | null,
    torre_interior: string | null,
    renovacion: boolean,
    anuencia_last_year: string | null,
    croquis_ubicacion: string | null,
    poliza_seguros: string | null,
    medidas_solicitud_torres: {
        norte_colindansia_calle: string | null,
        sur_colindansia_calle: string | null,
        este_colindansia_calle: string | null,
        oeste_colindansia_calle: string | null,
        norte_colindancia_mts: number,
        sur_colindancia_mts: number,
        este_colindancia_mts: number,
        oeste_colindancia_mts: number,
        superficie_total: number,
        superficie_total_construida: number,
        superficie_regularizar: number
    },
    licencia_construccion_perito: string | null,
    alineamiento_numero: string | null,
    constancia_terminacion_obra: string | null,
    documentos: {
        colindansia_norte: {
            file: any,
            data: any
        },
        colindansia_sur: {
            file: any,
            data: any
        },
        colindansia_este: {
            file: any,
            data: any
        },
        colindansia_oeste: {
            file: any,
            data: any
        },
        fachada: {
            file: any,
            data: any
        },
        torre_perspectiva: {
            file: any,
            data: any
        },
        torre_interior: {
            file: any,
            data: any
        },
        croquis_ubicacion: {
            file: any,
            data: any
        },
        poliza_seguro: {
            file: any,
            data: any
        },
        licencia_construccion_perito: {
            file: any,
            data: any
        },
        alineamiento_numero: {
            file: any,
            data: any
        },
        constancia_terminacion_obra: {
            file: any,
            data: any
        },
        anuencia_last_year: {
            file: any,
            data: any
        },
        constancia_uso_suelo: {
            file: any,
            data: any
        },
        contrato_arrendamiento: {
            file: any,
            data: any
        }
    },
    colindansia_norte_file: FileDocument,
    colindansia_sur_file: FileDocument,
    colindansia_este_file: FileDocument,
    colindansia_oeste_file: FileDocument,
    fachada_file: FileDocument,
    torre_perspectiva_file: FileDocument,
    torre_interior_file: FileDocument,
    croquis_ubicacion_file: FileDocument,
    poliza_seguro_file: FileDocument,
    licencia_construccion_perito_file: FileDocument,
    alineamiento_numero_file: FileDocument,
    constancia_terminacion_obra_file: FileDocument,
    anuencia_last_year_file: FileDocument,
    constancia_uso_suelo_file: FileDocument,
    estatus_revision: number,
    motivo_rechazo: string | null,
    documento_firmado: boolean,
    fecha_firma: string | null,
    constancia_uso_suelo_exist:  any
    edo_cuenta_status: any,
    contrato_arrendamiento_file: FileDocument,
    tipo_propiedad_id: number,
}

class SolicitudTorres implements _SolicitudTorres {
    id: number = 0;
    folio: string = "";
    no_folio: boolean = false;
    contribuyente_id: number = 0;
    clave_catastral: string = "";
    domicilio_id: number = 0;
    domicilio = new Domicilio();
    altura_mts: string = "";
    referencias: string = "";
    luz: boolean = true;
    bardeado: boolean = false;
    colindansia_norte: string = "";
    colindansia_sur: string = "";
    colindansia_este: string = "";
    colindansia_oeste: string = "";
    fachada: string = "";
    torre_perspectiva: string = "";
    torre_interior: string = "";
    renovacion: boolean = false;
    anuencia_last_year: string = "";
    croquis_ubicacion: string = "";
    poliza_seguros: string = "";
    medidas_solicitud_torres: any = {
        id: 0,
        norte_colindansia_calle: "",
        sur_colindansia_calle: "",
        este_colindansia_calle: "",
        oeste_colindansia_calle: "",
        norte_colindancia_mts: 0,
        sur_colindancia_mts: 0,
        este_colindancia_mts: 0,
        oeste_colindancia_mts: 0,
        superficie_total: 0,
        superficie_total_construida: 0,
        superficie_regularizar: 0
    };
    licencia_construccion_perito: string = "";
    alineamiento_numero: string = "";
    constancia_terminacion_obra: string = "";
    documentos: any = {
        colindansia_norte: {
            file: null as any,
            data: {} as any
        },
        colindansia_sur: {
            file: null as any,
            data: {} as any
        },
        colindansia_este: {
            file: null as any,
            data: {} as any
        },
        colindansia_oeste: {
            file: null as any,
            data: {} as any
        },
        fachada: {
            file: null as any,
            data: {} as any
        },
        torre_perspectiva: {
            file: null as any,
            data: {} as any
        },
        torre_interior: {
            file: null as any,
            data: {} as any
        },
        croquis_ubicacion: {
            file: null as any,
            data: {} as any
        },
        poliza_seguro: {
            file: null as any,
            data: {} as any
        },
        licencia_construccion_perito: {
            file: null as any,
            data: {} as any
        },
        alineamiento_numero: {
            file: null as any,
            data: {} as any
        },
        constancia_terminacion_obra: {
            file: null as any,
            data: {} as any
        },
        anuencia_last_year: {
            file: null as any,
            data: {} as any
        },
        constancia_uso_suelo: {
            file: null as any,
            data: {} as any
        },
        contrato_arrendamiento: {
            file: null as any,
            data: {} as any
        }
    };
    colindansia_norte_file: FileDocument = new FileDocument();
    colindansia_sur_file: FileDocument = new FileDocument();
    colindansia_este_file: FileDocument = new FileDocument();
    colindansia_oeste_file: FileDocument = new FileDocument();
    fachada_file: FileDocument = new FileDocument();
    torre_perspectiva_file: FileDocument = new FileDocument();
    torre_interior_file: FileDocument = new FileDocument();
    croquis_ubicacion_file: FileDocument = new FileDocument();
    poliza_seguro_file: FileDocument = new FileDocument();
    licencia_construccion_perito_file: FileDocument = new FileDocument();
    alineamiento_numero_file: FileDocument = new FileDocument();
    constancia_terminacion_obra_file: FileDocument = new FileDocument();
    anuencia_last_year_file: FileDocument = new FileDocument();
    constancia_uso_suelo_file: FileDocument = new FileDocument();
    estatus_revision: number = 1;
    motivo_rechazo: string | null = null;
    documento_firmado: boolean = false;
    fecha_firma: string | null = null;
    constancia_uso_suelo_exist: any;
    edo_cuenta_status: any;
    contrato_arrendamiento_file: FileDocument = new FileDocument();
    tipo_propiedad_id: number = 0;
}

export { SolicitudTorres, _SolicitudTorres, FileDocument };